<div id="accordionWebLinks" class="p-2">
  <div class="card box-shadow border-info">
    <div class="card-header bg-info-easie text-white p-0" id="headingOneWebLinks">
      <button class="btn btn-block text-white" data-toggle="collapse" data-target="#collapseOneWebLinks"
        aria-expanded="true" aria-controls="collapseOneWebLinks" (click)="sectionOpen = !sectionOpen">
        <i class="fas fa-link"></i> &nbsp; Web Links &nbsp;<i
          [class]="sectionOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
      </button>
    </div>

    <div id="collapseOneWebLinks" class="collapse" [class.show]="sectionOpen" aria-labelledby="headingOneWebLinks"
      data-parent="#accordionWebLinks">
      <div class="card-body segment-label p-1 ml-2">
        <ion-row>
          <ion-col size="12">
            <div class="input-group input-group-sm mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">
                  <ion-icon color="primary" name="link" (click)="openLink(webCoordinatoLinkObject.link1)"></ion-icon>
                </span>
              </div>
              <input type="text" [(ngModel)]="webCoordinatoLinkObject.link1" placeholder="Web Link 1"
                class="form-control" aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                [disabled]="!canEditWebLinks() || !subscriptionStatus">
            </div>
          </ion-col>
          <ion-col size="12">
            <div class="input-group input-group-sm mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">
                  <ion-icon color="primary" name="link" (click)="openLink(webCoordinatoLinkObject.link2)"></ion-icon>
                </span>
              </div>
              <input type="text" [(ngModel)]="webCoordinatoLinkObject.link2" placeholder="Web Link 2"
                class="form-control" aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                [disabled]="!canEditWebLinks() || !subscriptionStatus">
            </div>
          </ion-col>
          <ion-col size="12">
            <div class="input-group input-group-sm mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">
                  <ion-icon color="primary" name="link" (click)="openLink(webCoordinatoLinkObject.link3)"></ion-icon>
                </span>
              </div>
              <input type="text" [(ngModel)]="webCoordinatoLinkObject.link3" placeholder="Web Link 3"
                class="form-control" aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                [disabled]="!canEditWebLinks() || !subscriptionStatus">
            </div>
          </ion-col>
          <ion-col size="12">
            <button [disabled]="!subscriptionStatus" *ngIf="canEditWebLinks()" type="button"
              class="btn btn-block btn-outline-primary mb-1" (click)="updateLinks()">
              Update Links &nbsp; <i class="fas fa-arrow-alt-circle-right"></i>
            </button>
          </ion-col>
        </ion-row>
      </div>
    </div>
  </div>
</div>